import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { LoaderUI } from "Reuse/UI"; // UI component to display loader

// Create context for loader
const LoaderContext = createContext();

/**
 * LoaderProvider
 * ------------------
 * Provides global loader functionality.
 * Use `showLoader()` to show loader, `hideLoader()` to hide it.
 */
export const LoaderProvider = ({ children }) => {
  const [loaderCount, setLoaderCount] = useState([]);

  // Increment loader count to show loader
  // Stable functions (state setters only), so hooks can list them as deps
  const showLoader = useCallback(() => {
    setLoaderCount((prev) => [...prev, true]);
  }, []);

  // Decrement loader count to hide loader
  const hideLoader = useCallback(() => {
    setLoaderCount((prev) => prev.slice(0, -1));
  }, []);

  const value = useMemo(
    () => ({
      showLoader,
      hideLoader,
      isLoader: loaderCount.length > 0,
    }),
    [loaderCount, showLoader, hideLoader]
  );

  return (
    <LoaderContext.Provider value={value}>
      <LoaderUI />
      {children}
    </LoaderContext.Provider>
  );
};

// Hook to access loader functions
export const useLoader = () => useContext(LoaderContext);
